import React from 'react';
import Checkout from '../components/customer/Checkout';

export default function CheckoutPage() {
  return (
    <div style={{ minHeight: '100vh', padding: '20px', background: '#f5f5f5' }}>
      <Checkout />
    </div>
  );
}